<app-system-message></app-system-message>

<div [ngClass]="theme.getThemeClass()" class="container-fluid">
  <section [ngClass]="theme.getThemeClass()" class="card bg-light">
    <article
      [ngClass]="theme.getThemeClass()"
      class="card-body mx-auto article"
    >
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="card-title mt-0">Maintenance Logs — Latest per Device</h4>
        <div class="d-flex gap-2">
          <button
            class="btn btn-outline-secondary"
            (click)="loadLatest()"
            [disabled]="loading"
          >
            <i class="fa fa-rotate"></i> Refresh
          </button>
          <button class="btn btn-primary" (click)="openCreate()">
            <i class="fa fa-plus"></i> Create Log
          </button>
        </div>
      </div>

      <!-- Filters -->
      <form [formGroup]="filterForm" class="row g-2 mb-3">
        <div class="col-12 col-md-4">
          <label class="form-label">Filter by thing_name</label>
          <input
            class="form-control"
            placeholder="Search…"
            formControlName="thingQuery"
          />
        </div>
        <div class="col-12 col-md-4">
          <label class="form-label">From</label>
          <input
            class="form-control"
            type="datetime-local"
            formControlName="fromEpoch"
            appEpochDatetimeLocal
          />
        </div>
        <div class="col-12 col-md-4">
          <label class="form-label">To</label>
          <input
            class="form-control"
            type="datetime-local"
            formControlName="toEpoch"
            appEpochDatetimeLocal
          />
        </div>
        <div class="col-12">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            (click)="clearFilters()"
          >
            Clear Filters
          </button>
        </div>
      </form>

      @if (errorMsg) {
      <div class="text-danger mb-2">{{ errorMsg }}</div>
      }

      <!-- Table -->
      <div [ngClass]="theme.getThemeClass()" class="table-responsive">
        <table class="table table-hover align-middle">
          <thead>
            <tr>
              <th role="button" (click)="toggleSort('thing_name')">
                Device @if ((sortKey$ | async) === 'thing_name') {
                <i
                  class="fa"
                  [class.fa-arrow-up]="(sortDir$ | async) === 'asc'"
                  [class.fa-arrow-down]="(sortDir$ | async) === 'desc'"
                ></i>
                }
              </th>
              <th
                role="button"
                (click)="toggleSort('timestamp')"
                style="min-width: 220px"
              >
                Date/Time @if ((sortKey$ | async) === 'timestamp') {
                <i
                  class="fa"
                  [class.fa-arrow-up]="(sortDir$ | async) === 'asc'"
                  [class.fa-arrow-down]="(sortDir$ | async) === 'desc'"
                ></i>
                }
              </th>
              <th style="width: 220px">Actions</th>
            </tr>
          </thead>

          <tbody>
            @for (row of viewRows$ | async; track row) {
            <tr>
              <td class="fw-semibold">{{ row.thing_name }}</td>
              <td>{{ formatEpochLocal(row.timestamp) }}</td>
              <td>
                <div class="d-flex gap-2">
                  <button
                    class="btn btn-sm btn-primary"
                    (click)="openDetails(row.thing_name)"
                  >
                    Details
                  </button>
                  <button
                    class="btn btn-sm btn-primary"
                    (click)="
                      router.navigate(['/maintenance-log', row.thing_name])
                    "
                  >
                    Create Log
                  </button>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>

        @if (loading) {
        <div class="text-muted">Loading…</div>
        }
      </div>

      <!-- Details Modal (scrollable, padded, accordion per log row) -->
      @if (showDetailsModal) {
      <div class="modal-backdrop"></div>
      <div class="modal-shell">
        <div [ngClass]="theme.getThemeClass()" class="modal-card modal-xl">
          <div class="modal-header">
            <h5 class="modal-title">All Logs — {{ detailsThingName }}</h5>
            <button type="button" class="btn" (click)="closeDetails()">
              &#x2715;
            </button>
          </div>

          <div class="modal-body modal-scroll">
            @if (detailsLoading) {
            <div class="text-muted mb-2">Loading…</div>
            }

            <div class="accordion" id="logsAccordion">
              @for (log of detailsLogs; track trackByIndexModal($index, log); let i = $index) {
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading-{{ i }}">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    [attr.data-bs-target]="'#collapse-' + i"
                    aria-expanded="false"
                    [attr.aria-controls]="'collapse-' + i"
                  >
                    <div class="d-flex flex-column">
                      <strong>{{ formatEpochLocal(log.timestamp) }}</strong>
                      <small class="text-muted">
                        user: {{ log.dml_user_sub || "—" }}
                      </small>
                    </div>
                  </button>
                </h2>
                <div
                  [id]="'collapse-' + i"
                  class="accordion-collapse collapse"
                  [attr.aria-labelledby]="'heading-' + i"
                  data-bs-parent="#logsAccordion"
                >
                  <div class="accordion-body">
                    <ul class="nav nav-tabs small">
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          [class.active]="isDetailsTab(i, 'maintenance')"
                          (click)="setDetailsTab(i, 'maintenance')"
                          role="button"
                        >
                          Maintenance
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          [class.active]="isDetailsTab(i, 'xbee')"
                          (click)="setDetailsTab(i, 'xbee')"
                          role="button"
                        >
                          XBee Config
                        </a>
                      </li>
                    </ul>

                    <div class="tab-body pt-3">
                      @if (isDetailsTab(i,'maintenance')) {
                      <div class="row orientation-fix gy-2">
                        @for (key of maintenanceKeys; track key) {
                        <div class="col-12 col-md-8">
                          <div class="field-block">
                            <div class="field-label">{{ labelize(key) }}</div>
                            <div class="field-value">
                              @if (getValueModal(log, key)) {
                              <button
                                type="button"
                                class="btn btn-link p-0 note-link"
                                (click)="
                                  openNote(labelize(key), getValue(log, key))
                                "
                              >
                                View note
                              </button>
                              } @else {
                              <span class="text-muted">—</span>
                              }
                            </div>

                            <div class="field-ts">
                              {{
                                formatEpochLocal(getTs(log, key + "_timestamp"))
                              }}
                            </div>
                          </div>
                        </div>
                        }
                      </div>
                      }

                      @if (isDetailsTab(i, 'xbee')) {
                      <div class="row orientation-fix gy-2">
                        <div class="col-12">
                          <div class="mb-2 fw-semibold">Core</div>
                        </div>

                        @for (key of xbeeMainKeys; track key) {
                        <div class="col-12 col-md-8">
                          <div class="field-block">
                            <div class="field-label">{{ labelize(key) }}</div>
                            <div class="field-value">
                              @if (getValueModal(log, key)) {
                              <button
                                type="button"
                                class="btn btn-link p-0 note-link"
                                (click)="openNote(labelize(key), getValue(log, key))"
                              >
                                View note
                              </button>
                              } @else {
                              <span class="text-muted">—</span>
                              }
                            </div>

                            <div class="field-ts">
                              {{
                                formatEpochLocal(getTs(log, getXbeeMainTsKey(key)))
                              }}
                            </div>
                          </div>
                        </div>
                        }

                        <div class="col-12 mt-3">
                          <div class="fw-semibold">DIO Pins</div>
                        </div>

                        @for (pin of dioPins; track pin) {
                        <div class="col-12 col-md-6">
                          <div class="field-block">
                            <div class="field-label">{{ pin }}</div>
                            <div class="field-value">
                              @if (getValueModal(log, pin)) {
                              <button
                                type="button"
                                class="btn btn-link p-0 note-link"
                                (click)="openNote(pin, getValue(log, pin))"
                              >
                                View note
                              </button>
                              } @else {
                              <span class="text-muted">—</span>
                              }
                            </div>
                            <div class="field-ts">
                              {{
                                formatEpochLocal(getTs(log, pin + "_timestamp"))
                              }}
                            </div>
                          </div>
                        </div>
                        }

                        <div class="col-12 mt-3">
                          <div class="fw-semibold">Other</div>
                        </div>

                        @for (key of xbeeTailKeys; track key) {
                        <div class="col-12 col-md-6">
                          <div class="field-block">
                            <div class="field-label">{{ key.toUpperCase() }}</div>
                            <div class="field-value">
                              @if (getValueModal(log, key)) {
                              <button
                                type="button"
                                class="btn btn-link p-0 note-link"
                                (click)="openNote(key, getValue(log, key))"
                              >
                                View note
                              </button>
                              } @else {
                              <span class="text-muted">—</span>
                              }
                            </div>
                            <div class="field-ts">
                              {{
                                formatEpochLocal(getTs(log, key + "_timestamp"))
                              }}
                            </div>
                          </div>
                        </div>
                        }
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
            <!-- /accordion -->
          </div>

          <div class="modal-footer">
            <button class="btn btn-outline-secondary" (click)="closeDetails()">
              Close
            </button>
          </div>
        </div>
      </div>
      }
      <!-- Create Modal -->
      @if(showCreateModal){
      <div class="modal-backdrop"></div>
      <div class="modal-shell">
        <div [ngClass]="theme.getThemeClass()" class="modal-card">
          <div class="modal-header">
            <h5 class="modal-title">Create Log</h5>
            <button type="button" class="btn" (click)="closeCreate()">
              &#x2715;
            </button>
          </div>
          <div style="padding: 8px" class="modal-body">
            @if (createLoading) {
              <div class="text-muted">Loading devices…</div>
            } @else {
              <label class="form-label">Select a device</label>
              <select class="form-select" [(ngModel)]="selectedDevice">
                <option value="" disabled selected>Select…</option>
                @for (t of deviceOptions; track t) {
                <option [value]="t">
                  {{ t }}
                </option>
                }
              </select>
            }
          </div>
          <div class="modal-footer">
            <button class="btn btn-outline-secondary" (click)="closeCreate()">
              Cancel
            </button>
            <button
              class="btn btn-primary"
              (click)="routeToCreate()"
              [disabled]="!selectedDevice"
            >
              Create
            </button>
          </div>
        </div>
      </div>
      }

      <!-- Note Modal (small, padded) -->
      @if(showNoteModal) {
      <div class="modal-backdrop stack"></div>
          <div class="modal-shell stack">
            <div [ngClass]="theme.getThemeClass()" class="modal-card modal-sm">
              <div class="modal-header">
                <h5 class="modal-title">{{ noteTitle }}</h5>
                <button type="button" class="btn" (click)="closeNote()">
                  &#x2715;
                </button>
              </div>
              <div class="modal-body modal-scroll">
                <pre class="note-pre">{{ noteText }}</pre>
              </div>
              <div class="modal-footer">
                <button class="btn btn-primary" (click)="closeNote()">Close</button>
              </div>
            </div>
       </div>
       }

    </article>
  </section>
</div>
